export const ATTENDANCE_OPTIONS = [
    { value: 1, label: "Si" }, 
    { value: 2, label: "No" }
];
export const VALUES_BY_ATTENDANCE_OPTIONS = {
    0: null,
    1: true,
    2: false
};

export const RADIO_BOOL_OPTIONS = [
    { value: true, label: "Si" }, 
    { value: false, label: "No" }
];